import { CardDeleteComponent } from './dom/CardDeleteButton';
import { DatePicker } from './dom/DatePicker';
import { SVGInject } from './dom/SVGInjector';
import { CopyOrdererToDelivery } from './dom/CopyOrdererToDelivery';
import { DisableDuplicateSubmit } from './dom/DisableDuplicateSubmit';
import { HideButtonNoReferer } from './dom/HideButtonNoReferer';
const DomComponents = [SVGInject, DatePicker, CardDeleteComponent, CopyOrdererToDelivery, DisableDuplicateSubmit, HideButtonNoReferer];
DomComponents.map(m => {
    window.addEventListener('load', () => {
        m.Load();
    });
    window.addEventListener('DOMContentLoaded', () => {
        m.DomContentLoaded();
    });
});
